import { reactNode } from '@shared/node-v1.0.0'

import v100 from '@nodes/collapse-v1.0.0'

export default reactNode(
	'Collapse',
	{
		'v1.0.0': v100,
	},
	{ allowChildren: true, docs: '' }
)
